const THREE = require('three')  
import ImageService from '@/services/ImageService'
import { DEG_TO_RAD, map, clamp } from 'src/helpers/MathUtils'
// import SpaceshipSpritesheet from '@/assets/sprites/spaceship' 
import MovieClip from 'src/helpers/MovieClip' 
import frag from '@/shaders/spaceship/fragment.glsl'
import vert from '@/shaders/spaceship/vertex.glsl'
 
class SpaceFace extends MovieClip {

  constructor(config) {

    super(config);

    this.FRAME_LENGTH = 16;
    this.position.z = -100; 
    this.scale.x = this.scale.y = this.scale.z = 0.2;
    this.tg = 0;
  
    this.setup(); 

  } 

  setup() { 

    this.tl = new TimelineMax(); 
    this.tweenObj = {
      color: '#33c8ff'
    }
    this.tl.to(this.tweenObj, 1, {
      colorProps:{
        color: '#945488' 
      }, 
      ease: Linear.easeNone
    });

    this.geometry = new THREE.PlaneGeometry(this.config.frame_width , this.config.frame_height , 32);
    this.material = new THREE.ShaderMaterial({
      uniforms: {
        texture: {
          type: 't',
          value: this.config.texture
        },
        // tex width / height
        tSize: {
          type: 'v2',
          value: new THREE.Vector2(this.config.spritesheet_width, this.config.spritesheet_height)
        },
        // frame trim width / height
        fTrimSize: {
          type: 'v2',
          value: new THREE.Vector2()
        },
        // frame original width / height
        fOriginalSize: {
          type: 'v2',
          value: new THREE.Vector2(this.config.frame_width, this.config.frame_height)
        },
        // frame x / y offset
        fOffset: {
          type: 'v2',
          value: new THREE.Vector2()
        },
        fTrimOffset: {
          type: 'v2',
          value: new THREE.Vector2()
        },
        opacity: {
          type: 'f',
          value: 1.0
        },
        color: {
          type: 'v3',
          value: new THREE.Color('#33c8ff')
        }
      },
      transparent: this.config.transparent, 
      vertexShader: vert,
      fragmentShader: frag
    });

    this.mesh = new THREE.Mesh(this.geometry, this.material  );
    this.add(this.mesh);
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }

  resize() {
      
  }

  tick(dy, scroll_ratio){

    this.tg += ( (dy * 0.2) - this.tg) * 0.1;

    this.position.y = dy + map(clamp(scroll_ratio, 0, 0.5), 0, 0.5, 600, -400);
    this.position.x = Math.cos( scroll_ratio * 30) * 300;
    this.position.z = -1000 + Math.sin( scroll_ratio * 30) * 400; 

    this.tgFrame = (Math.round(Math.abs(this.tg)) % this.FRAME_LENGTH );
    this.stop(this.tgFrame);

    let progress = clamp(scroll_ratio * 2, 0, 1)

    this.tl.progress(progress );
   this.material.uniforms.color.value = new THREE.Color(this.tweenObj.color);

  }
 
 
}

export default SpaceFace